export const isSyntaxError = (error) => {
  return error instanceof SyntaxError
}
